import { render, staticRenderFns } from "./ConclusionCard.vue?vue&type=template&id=0b107062&scoped=true&"
import script from "./ConclusionCard.vue?vue&type=script&lang=js&"
export * from "./ConclusionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b107062",
  null
  
)

export default component.exports